import { OrganisationPreferenceKey } from '@/enum/global.enum'
import { useOrganisationPreferences } from '@/hooks/use-organisation-preference'
import { DEFAULT_ORGANISATION_TIMEZONE, resolveTimeZone } from '@/utils/timezone.utils'

/**
 * IANA timezone chosen by the organisation admin.
 * Falls back to Australia/Sydney so existing organisations keep the previous calendar.
 */
export const useOrganisationTimeZone = (): string => {
  const { getOrganisationPreferenceValue } = useOrganisationPreferences()
  const stored = getOrganisationPreferenceValue(OrganisationPreferenceKey.TIMEZONE, DEFAULT_ORGANISATION_TIMEZONE)
  return resolveTimeZone(stored)
}
